import * as Yup from 'yup'

export const forgetPasswordSchema = (languageData) => Yup.object().shape({
  email: Yup.string().required(languageData?.emailUserNameRequired)
})
